import { endOfDay } from "date-fns";

export default {
  install(Vue) {
    Vue.prototype.$_globalMixin_formatDateRequestToSGT = function(date) {
      const { format, utcToZonedTime } = require("date-fns-tz");
      const singaporeTime = utcToZonedTime(date, "Asia/Singapore");

      const formattedDate = format(singaporeTime, "yyyy-MM-dd", {
        timeZone: "Asia/Singapore"
      });

      const formattedTime = format(singaporeTime, "HH:mm:ss.SSSXXX", {
        timeZone: "Asia/Singapore"
      });
      return formattedDate + "T" + formattedTime;
    };

    Vue.prototype.$_globalMixin_displaySGT = function(
      date,
      dateFormat = "dd/MM/yyyy HH:mm:ss"
    ) {
      const { format, utcToZonedTime } = require("date-fns-tz");
      const singaporeTime = utcToZonedTime(date, "Asia/Singapore");

      const formattedDate = format(singaporeTime, dateFormat, {
        timeZone: "Asia/Singapore"
      });

      return formattedDate;
    };

    Vue.prototype.$_globalMixin_formatDateToSGTEod = function(date) {
      const convertedDate = endOfDay(date);
      const result = this.$_globalMixin_formatDateRequestToSGT(convertedDate);

      return result;
    };
  }
};
